import Analytics from '@/components/Analytics'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import SectionContainer from '@/components/SectionContainer'
import { ThemeProviders } from '@/components/ThemeProviders'
import iubendaConfig from '@/data/iubenda'
import { ConsentGate, IubendaProvider } from '@/lib/iubenda'
import { PathnameProvider } from '@/lib/location'
import type { ComponentType } from 'react'

export default function App({ pathname, Page }: { pathname: string; Page: ComponentType }) {
  return (
    <PathnameProvider value={pathname}>
      <ThemeProviders>
        <IubendaProvider config={iubendaConfig}>
          <div className="mx-auto max-w-3xl xl:max-w-6xl">
            <Header />
          </div>

          <SectionContainer>
            <div className="flex h-screen flex-col justify-between font-sans">
              {/* Misurazione attiva solo con il consenso a esperienza e marketing */}
              <ConsentGate purposes={['experience', 'marketing']}>
                <Analytics />
              </ConsentGate>

              <main className="mb-auto">
                <Page />
              </main>
              <Footer />
            </div>
          </SectionContainer>
        </IubendaProvider>
      </ThemeProviders>
    </PathnameProvider>
  )
}
